import React from 'react'
import { useQuery } from 'react-apollo'
import { format } from 'date-fns'

import RentalsTable from './rentals-table'

import ACCOUNT_QUERY from '../../../../../graphql/queries/account.gql'

const getDateField = date => ({
  label: format(new Date(date), 'd/MM/yyyy'),
  value: date
})

const getPurchases = (accountData) => {
  const purchases = accountData?.account?.purchases?.items || []

  return purchases
    .filter(purchase => !purchase.product?.renewable)
    .map(purchase => ({
      boxart: purchase.contentItem?.tile?.image || purchase.contentItem?.images?.[0]?.uri || '',
      title: purchase.contentItem?.title || null,
      rented: getDateField(purchase.startAvailable),
      expires: getDateField(purchase.endViewable || purchase.endAvailable),
      price: `$${purchase.total}`
    }))
}

function Rentals() {
  const {
    data: accountData,
    loading: accountLoading,
    error: accountError
  } = useQuery(ACCOUNT_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  })

  if (accountLoading || accountError) {
    return null
  }

  const purchases = getPurchases(accountData)

  return <RentalsTable purchases={purchases} />
}

export default Rentals
